import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../context/ThemeContext';

const Logo = ({ 
  size = 'md', 
  withGlow = false,
  className = '' 
}) => {
  const { theme } = useTheme();
  const sizes = {
    sm: 'h-8 w-auto',
    md: 'h-12 w-auto',
    lg: 'h-16 w-auto',
    xl: 'h-24 w-auto',
    '2xl': 'h-32 w-auto',
  };

  const glowAnimation = withGlow
    ? {
        filter: [
          'drop-shadow(0 0 10px rgba(203, 163, 90, 0.5))',
          'drop-shadow(0 0 20px rgba(203, 163, 90, 0.8))',
          'drop-shadow(0 0 10px rgba(203, 163, 90, 0.5))',
        ],
      }
    : {};

  const logoSrc = theme === 'dark' ? '/logo-white.svg' : '/logo.png';

  return (
    <motion.img
      src={logoSrc}
      alt="AFSC Logo"
      className={`${sizes[size]} ${className}`}
      animate={withGlow ? glowAnimation : {}}
      transition={{
        duration: 3,
        repeat: Infinity,
        ease: 'easeInOut',
      }}
    />
  );
};

export default Logo;

